import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes';

/** Created once the session is ready, so it reads the URL consumeCallback() already rewrote (C2). */
export function WorkspaceRouter() {
  const [router] = useState(() => createBrowserRouter(routes));
  return <RouterProvider router={router} />;
}
